import { IResource } from '@/types/course.d';
import fetch from './index';

// ------------------ COURSER-INFO 课程信息
// 获取课程信息
const getCList = (params: Object) => fetch.axios_admin.get('/course', { params });

const getQlist = (cid: string) => fetch.axios_admin.get(`/course/chapter/questions/?cid=${cid}&r=1`);

const getChapter = (cid: string) => fetch.axios_admin.get(`/course/chapter?cid=${cid}`);

// 获取课时配置基数
const getCourseStandardNumber = () => fetch.axios_admin.get('/courseStandardNumber');

// 添加正式课
const addCourse = (data: FormData) => fetch.axios_admin.post('/course', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 修改正式课
const editCourse = (data: FormData) => fetch.axios_admin.put('/course', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 移除正式课
const removeCourse = (id: string) => fetch.axios_admin.remove(`/course?id=${id}`);

// ------------------ COURSER-CHAPTER 课程信息
// 通过章节问题移除题库
const removeQuesByCid = (params: { cid: string, qidList: string }) => fetch.axios_admin.remove('/course/chapter/questions', { params });

// 获取课程信息
const getCourseDetail = (id: string) => fetch.axios_admin.get('/course/detail', { params: { id } });

const addChapter = (data: FormData) => fetch.axios_admin.post('/course/chapter', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 修改章节信息
const editChapter = (data: FormData) => fetch.axios_admin.put('/course/chapter', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

const removeChapter = (id: string) => fetch.axios_admin.remove(`/course/chapter?id=${id}`);

const getAsset = (pid: string) => fetch.axios_admin.get(`/course/chapter/findByPid?pid=${pid}`);

// ------------------ COURSER-RESOURCE 课程资源
// 获取资源
const getCourse = (pid: string) => fetch.axios_admin.get(`/course/chapter/stepId?cid=${pid}`);

// 删除资源
const removeRescource = (id: string) => fetch.axios_admin.remove(`/course/chapter/resource/${id}`);

// 课程资源大文件上传专用超时时间，单位毫秒；100M 左右的 ZIP 在弱网下可能超过默认 10 秒。
const RESOURCE_UPLOAD_TIMEOUT = 10 * 60 * 1000;

/**
 * 上传课程章节资源文件。
 * @param {FormData} data 上传表单数据，包含资源 pid 和 resourcePath 文件对象。
 * @returns {Promise<any>} 后端上传接口返回的请求 Promise。
 */
const uploadFile = (data: FormData) => fetch.axios_admin.put('/course/chapter/resourceElse', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
  timeout: RESOURCE_UPLOAD_TIMEOUT,
});

const uploadHtmlPackage = (data: FormData) => fetch.axios_node.post('/api/course-html-resources/upload', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 上传图片
const uploadImage = (data: FormData) => fetch.axios_admin.put('/course/chapter/resource/updateImage', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 获取资源文件
const getFile = (pid: string) => fetch.axios_admin.get(`/course/chapter/resource/findName?pid=${pid}`);

const getHtmlResource = (pid: string) => fetch.axios_node.get(`/api/course-html-resources/${pid}`);

const addRescource = (data: IResource) => fetch.axios_admin.post('/course/chapter/resourceBasic', data);

const changeResourceQuestion = (data: { pid: string; expectedOjQuestionPid: string | null; ojQuestionPid: string }) => fetch.axios_admin.put('/course/chapter/resourceBasic?questionOnly=true', data);

const editRescource = (data: IResource) => fetch.axios_admin.put('/course/chapter/resourceBasic', data);

// 获取用户
const getUser = (userTitle: string) => fetch.axios_admin.get(`/user/userTitle?userTitle=${userTitle}`);

// 获取作品
const getWorks = (userId: string, title: string, ver: number | undefined) => fetch.axios_admin.get(
  `/course/chapter/resource/findTitle?userId=${encodeURIComponent(userId)}`
  + `&title=${encodeURIComponent(title)}&ver=${ver}`,
);

// 关联作品
const setContract = (data: { pid: string, projectPid: string }) => fetch.axios_admin.put('/course/chapter/resource', data);

// ------------------ COURSER-HOMEWORK 课后作业
// 获取作业
const getHomework = (pid: string) => fetch.axios_admin.get(`course/chapter/homework?cid=${pid}`);

// 删除作业
const removeHomework = (id: string) => fetch.axios_admin.remove(`course/chapter/homework/${id}`);

// 添加作业
const addHomeWork = (data: FormData) => fetch.axios_admin.post('/course/chapter/homework', data);

// 修改作业
const editHomeWork = (data: FormData) => fetch.axios_admin.put('/course/chapter/homework', data);

// ------------------ COURSER-VIDEO 视频
// 添加视频
const addVideo = (data: FormData) => fetch.axios_admin.post('/course/chapter/video', data);

// 修改视频
const editVideo = (data: FormData) => fetch.axios_admin.put('/course/chapter/video', data);

// 删除视频
const removeVideo = (id: string) => fetch.axios_admin.remove(`/course/chapter/video?chapterVideoId=${id}`);

// 获取视频
const getViideo = (id: string) => fetch.axios_admin.get(`/course/chapter/video/?cid=${id}`);

// ------------------ COURSER-KNOWEDGE 知识点
// 获取知识点
const getKnowedge = (id: string) => fetch.axios_admin.get(`/course/chapter/stepKnowledge?cid=${id}&r=1`);

// 添加知识点
const addKnowedge = (data: FormData) => fetch.axios_admin.post('/course/chapter/knowledge', data);

// 修改知识点
const editKnowedge = (data: any) => fetch.axios_admin.put('/course/chapter/knowledge', data);

// 删除知识点
const removeKnowedge = (id: string) => fetch.axios_admin.remove(`/course/chapter/knowledge?rid=${id}`);

// 设置章节问题排序
const setCourseQuesSort = (data: Array<{id: string, sort: string}>, cid: string) => fetch.axios_admin.put(`/course/chapter/question/sort?cid=${cid}`, data);

// 获取章节所关联的素材资源
const getChapterAsset = (cid: string) => fetch.axios_admin.get(`course/chapter/scratch/material?cid=${cid}`);

// 删除章节所关联的素材资源
const removeAssetById = (sid: string, cid: string) => fetch.axios_admin.remove(`course/chapter/scratch/material?sid=${sid}&cid=${cid}`);

// 存图片
const picStore = (data: FormData) => fetch.axios_admin.post('/common/rich/file', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 复制课包
const copyCourse = (data: any) => fetch.axios_admin.post('/copyCourse', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// ------------------ COURSER-TYPE 课程分类
// 查询课程类型
const getType = () => fetch.axios_admin.get('course/type');

// 添加课程类型
const addType = (data: FormData) => fetch.axios_admin.post('course/type', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 更新课程所属关系
const updataCourseType = (data: Object) => fetch.axios_admin.put('/course/type/tree ', data);

// 修改课程类型
const editType = (data: FormData) => fetch.axios_admin.put('course/type', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// <---视频功能操作接口-->

const findVideoList = (title: string) => fetch.axios_admin.get(`/findVideo?t=${title}`);

//  关联视频
const relevanceVideo = (data: object) => fetch.axios_admin.post('/course/chapter/relevanceVideo', data);

//  修改关联视频
const updataRelevance = (data: object) => fetch.axios_admin.put('/course/chapter/alterVideo', data);

// 修改章节内容
const updataChapterContent = (data: FormData) => fetch.axios_admin.put('/course/chapter/content', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 修改课程内容
const updataFormalCourseContent = (data: FormData) => fetch.axios_admin.put('/course/content', data, {
  headers: { 'Content-Type': 'multipart/form-data' },
});

// 查询章节内容信息
const getChapterContent = (cid: string) => fetch.axios_admin.get(`/course/chapter/content?cid=${cid}`);


// ------------------ COURSER-ASSIGNMENT 课后习题

// 查询当前章节下的习题
const getChapterAssignment = (params: string) => {
  const formData = new URLSearchParams();
  formData.append('chapterPid', params);
  return fetch.axios_admin.post('/course/chapter/assignment/list', formData, {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
  });
};

// 删除习题
const removeAssignment = (pids: number[] | string[]) => fetch.axios_admin.post('/course/chapter/assignment/batchDelete', pids);

const getQJQuestion = (params: any) => fetch.axios_admin.post('/course/chapter/assignment/listOJ', params);

/** 按完整题号查询公共题库的公开及隐藏编程题；questionId 为展示题号，返回候选摘要列表。 */
const getResourceQuestions = (questionId: string) => fetch.axios_admin.post('/course/chapter/assignment/listOJ?resourceQuestion=true', { params: { questionId } });

// 批量添加题目到作业
const batchAddQuestions = (data: Array<{ chapterPid: string; ojQuestionPid: number }>) => fetch.axios_admin.post('/course/chapter/assignment/BatchAddOrUpdate', data);

// 获取作业列表
const getAssignmentList = (params: { chapterPid: string }) => fetch.axios_admin.get('/course/chapter/assignment/list', { params });

export default {
  getCList,
  getQlist,
  getChapter,
  getCourseStandardNumber,
  removeQuesByCid,
  getCourseDetail,
  setCourseQuesSort,
  getChapterAsset,
  removeAssetById,
  picStore,
  addCourse,
  editCourse,
  removeCourse,
  editChapter,
  removeChapter,
  addChapter,
  getAsset,
  getCourse,
  removeRescource,
  uploadFile,
  uploadHtmlPackage,
  getFile,
  getHtmlResource,
  addRescource,
  editRescource,
  changeResourceQuestion,
  getUser,
  getWorks,
  setContract,
  uploadImage,
  getHomework,
  removeHomework,
  addHomeWork,
  editHomeWork,
  addVideo,
  editVideo,
  getViideo,
  removeVideo,
  getKnowedge,
  addKnowedge,
  editKnowedge,
  removeKnowedge,
  copyCourse,
  getType,
  addType,
  editType,
  relevanceVideo,
  updataRelevance,
  updataChapterContent,
  updataFormalCourseContent,
  getChapterContent,
  updataCourseType,
  findVideoList,
  getChapterAssignment,
  removeAssignment,
  getQJQuestion,
  getResourceQuestions,
  batchAddQuestions,
  getAssignmentList,
};
